import { COUNTRY_CODE_FOR_SLOVAKIA } from '@/config';

/**
 * Function compare two address returns true if addresses are same
 * @returns boolean
 * */
export const compareAddresses = (addressA, addressB) => {
  const {
    street, streetNumber, city, zip,
  } = addressA;
  const {
    street: streetB, streetNumber: streetNumberB, city: cityB, zip: zipB,
  } = addressB;
  return street === streetB && streetNumber === streetNumberB && city === cityB && zip === zipB;
};

/**
 * Function returns true if it is Slovak address
 * @param address - Kotlin address
 *
 * @returns boolean
 * */
export const isSlovakAddress = (address) => address.country?.value === COUNTRY_CODE_FOR_SLOVAKIA;

/**
 * Function check if one of parameter is empty then returns true.
 * NOT INCLUDED COUNTRY
 *
 * @returns boolean
 * */
export const isEmptyAddress = (address) => !address.city || !address.street || !address.streetNumber || !address.zip;

export const addressIsNotFullyFilled = (address) => !address.city && !address.street && !address.streetNumber && !address.zip;

export const addressNotFilled = (address) => !address.city || !address.street || !address.streetNumber || !address.zip;
